export const getEnvironmentValue = (ENV_NAME, fallBack) => {
  let envValue = fallBack;

  if (typeof process !== 'undefined' && process?.env[ENV_NAME] !== undefined) {
    if (!process.browser || process?.env.NODE_ENV !== 'production') {
      envValue = process.env[ENV_NAME];
    }
  }

  if (typeof window !== 'undefined' && window[ENV_NAME]) {
    envValue = window[ENV_NAME];
  }

  return envValue;
};

export const SESSION_TIME = 1000 * 60 * 30; // 30 minutes session time, can be configured to come from env variables
export const CDN_URL = getEnvironmentValue('CDN_URL', 'https://cdn.hey.car');

export const DEFAULT_LOCALE = getEnvironmentValue('DEFAULT_LOCALE', 'de');
export const BASE_URL = getEnvironmentValue(
  'BASE_URL',
  'https://staging.hey.car',
);
export const IMAGE_SERVICE_URL = getEnvironmentValue(
  'IMAGE_SERVICE_URL',
  'https://img.hey.car',
);

export const CONTENTFUL_HEYCAR = getEnvironmentValue(
  'CF_SPACE_DE',
  'car0nghph155',
);

// in create-react-app, NODE_ENV is built-in. It always equals:
// -  'test' (for tests)
// - 'development' (development environment)
// - 'production' (production bundle)

// NODE_ENV cannot be overriden manually
// other environment variables must begin with `REACT_APP_`
export const PRODUCTION =
  process.env.NODE_ENV === 'production' ||
  process.env.REACT_APP_TEST_PRODUCTION;

export const STAGING = getEnvironmentValue('REACT_APP_NODE_ENV') === 'staging';
export const DEVELOPMENT = process.env.NODE_ENV === 'development';

// PUBLIC_URL is a builtin environment variable in create-react-app for providing the path to the `public` directory
export const PUBLIC_BASE = getEnvironmentValue('PUBLIC_URL', '');

// variable for accessing current Sentry release hash
export const SENTRY_RELEASE = process.env.REACT_APP_SENTRY_RELEASE;

// boolean for enabling Sentry error reporting
export const SENTRY_IS_ENABLED = getEnvironmentValue(
  'REACT_APP_SENTRY_IS_ENABLED',
);

// dsn for Sentry
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const commonUrl = `https://api.common.${
  STAGING ? 'staging' : 'prod'
}.group-mobility-trader.${STAGING ? 'de' : 'com'}`;
const deUrl = `https://api.${STAGING ? 'staging.' : ''}hey.car`;
export const API_URL = getEnvironmentValue('API_URL', deUrl);
export const COMMON_URL = getEnvironmentValue('COMMON_URL', commonUrl);
